<template>
  <div>
    <vs-divider>Facturas</vs-divider>
    <vx-card title="Facturas a cliente" class="mt-5">
      <vs-table :data="project.clientInvoice">
        <template slot="thead">
          <vs-th>TRX</vs-th>
          <vs-th>CID</vs-th>
          <vs-th>Nombre/Razon social</vs-th>
          <vs-th>Concepto</vs-th>
          <vs-th>Monto</vs-th>
          <vs-th>F. Confirmación</vs-th>
          <vs-th>Factura</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="ci in data" :key="ci.id">
            <vs-td>{{ ci.trxType }}</vs-td>
            <vs-td>{{ ci.profileId }}</vs-td>
            <vs-td>
            <span>
              {{ ci.profileName }}
            </span>
            </vs-td>
            <vs-td style="width: 250px">{{ ci.concept }}</vs-td>
            <vs-td md-numeric>{{ ci.amount | currency }}</vs-td>
            <vs-td>{{ ci.trxConfirmationDate }}</vs-td>
            <vs-td style="width: 154px">
              <vs-button
                  class="text-dark"
                  color="secondary" icon="picture_as_pdf" @click="openFile(ci.pdfFile)">
              </vs-button>
              <md-button
                  class="text-dark"
                  color="secondary" icon="insert_drive_file" @click="openFile(ci.xmlFile)">
              </md-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>


    <vx-card title="Facturas a proveedor" class="mt-5" v-if="!project.isApplicantLoan()">
      <vs-table :data="project.supplierInvoice">
        <template slot="thead">
          <vs-th style="width: 20px;">TRX</vs-th>
          <vs-th>SID</vs-th>
          <vs-th>Nombre/Razon social</vs-th>
          <vs-th>Concepto</vs-th>
          <vs-th>Monto</vs-th>
          <vs-th>F. Confirmación</vs-th>
          <vs-th>Factura</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="si in data" :key="si.id">
            <vs-td>{{ si.trxType }}</vs-td>
            <vs-td>{{ si.profileId }}</vs-td>
            <vs-td>{{ si.profileName }}</vs-td>
            <vs-td style="width: 250px">{{ si.concept }}</vs-td>
            <vs-td md-numeric>{{ si.amount | currency }}</vs-td>
            <vs-td>{{ si.trxConfirmationDate }}</vs-td>
            <vs-td style="width: 150px">
              <vs-button
                  class="text-dark"
                  color="secondary" icon="picture_as_pdf" @click="openFile(si.pdfFile)">
              </vs-button>
              <md-button
                  class="text-dark"
                  color="secondary" icon="insert_drive_file" @click="openFile(si.xmlFile)">
              </md-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import WithdrawalsRgModule from "@views/admin/treasury/withdrawals-rg-module";
import {mapState} from "vuex";
import {LoanProject} from "@/models/LoanPayment/Project";

export default {
  name: "loan-project-invoices-card",
  components: {WithdrawalsRgModule},
  props: {
    project: {
      type: LoanProject
    }
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  methods: {
    openFile(file) {
      window.open(
          `${process.env.VUE_APP_STORAGE_DOMAIN}/storage/private/rg-invoice/0/${file}?access_token=${this.user.access_token}`,
          '_blank'
      );
    }
  }
}
</script>

<style scoped>

</style>
